<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Liderança na indústria da carne</h2>
          <p>
            A JBS adquire a <strong>Tasman Group</strong> na Austrália; a
            <strong>Smithfield Beef</strong>, divisão de bovinos da
            <strong>Smithfield Foods</strong> nos EUA; e os confinamentos da
            <strong>Five Rivers</strong>, com capacidade de 2 milhões de animais
            por ano.
          </p>
          <img
            src="../assets/img/2008/2008-1.jpg"
            alt=""
            @click="showMultiple(0)"
          />
        </div>
        <div class="formato__warpper__item--black">
          <div class="images">
            <img
              src="../assets/img/2008/2008-2.png"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/2015/05/14/g/20150514-44403-nac-60-gui-d6-not-kqkeqhh.jpg'
                )
              "
            />
          </div>
          <div>
            <h2>A busca pela comida local</h2>
            <p>
              Outra tendência surgida nos anos 2000 que merece destaque é o
              “<strong><i>farm to table</i></strong
              >”: criada pelo chef americano Dan Barber, essa corrente prega que
              as pessoas devem buscar consumir alimentos produzidos próximos da
              sua cidade. É uma forma não só de comer comida mais fresca, mas
              também de reduzir custos com logística e impactos ambientais para
              o planeta, defende o chef, conhecido pelo restaurante Blue Hill at
              Stone Barns.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from './Ano.vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ['ano'],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, '_blank');
    },
    showMultiple(index) {
      this.imgsRef = [
        {
          src: require('@/assets/img/2008/2008-1-full.jpg'),
          title:
            '2008 - Expansão dos negócios no exterior e consolidação da liderança na indústria da carne.',
        },
      ];
      this.indexRef = index; // index of imgList
      this.onShow();
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 480px 1fr;
    justify-content: space-between;
    gap: 75px;
    @include media('<=desktop') {
      grid-template-columns: 1fr;
    }
  }
  img {
    cursor: pointer;
    transition: 0.3s ease-in-out;
    &:hover {
      transform: scale(1.1);
    }
  }
  &__warpper {
    position: relative;

    &__item {
      position: relative;
      @include media('<=desktop') {
        padding: 0 20px;
      }
      &--image {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        img {
          margin: 10px 0;
        }
        span {
          position: absolute;
          left: -70px;
          bottom: 50px;
          width: 65px;
          color: color(cBlue4);
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cGreen);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }
      img {
        cursor: pointer;
      }

      &--black {
        padding-block: 50px;
        display: grid;
        grid-template-columns: 265px 1fr;
        gap: 38px;
        align-content: center;
        @include media('<=desktop') {
          grid-template-columns: 1fr;
          background: color(cBlue5);
          padding: 40px 20px;
        }
        img {
          margin: 20px 0;
        }
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          max-width: 371px;
          margin: 0 auto;
        }
        h2 {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          max-width: 371px;
          margin: 0 auto;
          margin-bottom: 10px;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          position: relative;
          max-width: 370px;
          margin: 10px auto;
          &::before {
            content: '\e901';
            font-family: 'icomoon' !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: '';
      background: color(cBlue5);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media('<=desktop') {
        display: none;
      }
    }
  }
}
</style>
